// extracted by mini-css-extract-plugin
module.exports = {"borrowerIcon":"BorrowerIcon_borrowerIcon__1g80A"};